import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { UserContext } from '@hdms/shared/common-types';

export interface DeliveryAddressContextResponse {
  loggedInContext: UserContext;
}

@Injectable({
  providedIn: 'root'
})
export class DeliveryAddressesContextGqlService extends Query<DeliveryAddressContextResponse> {
  override document = gql`
    query DeliveryAddressesContext {
      loggedInContext {
        id
        ... on Customer {
          companyAccount {
            id
            originId
          }
        }
        ... on Employee {
          customerCompanyAccount {
            id
            originId
          }
        }
      }
    }
  `;
}
